import { useEffect, useState } from "react";
import { addExpense } from "./TransactionService";
import { getAllAccounts } from "../accounts/AccountService";
import { getAllCategories } from "../categories/CategoryService";
import { getAllMerchants } from "../merchants/MerchantService";
import { getAllTags } from "../tags/TagService";
import "./ExpenseForm.css";

export default function ExpenseForm(){

  const [accounts,setAccounts]=useState([]);
  const [categories,setCategories]=useState([]);
  const [merchants,setMerchants]=useState([]);
  const [tags,setTags]=useState([]);
  const [errors, setErrors] = useState({});

  const [form,setForm]=useState({
    accountId:"",
    categoryId:"",
    merchantId:"",
    amount:"",
    date:"",
    description:"",
    tags:[]
  });

  useEffect(()=>{
    load();
  },[]);

  const formatAccountLabel = (account)=>{
    const name = account?.accountName || "Account";
    const accountNumber = account?.accountNumber ? String(account.accountNumber) : "";
    const last4 = accountNumber ? accountNumber.slice(-4) : "";
    const numberLabel = last4 ? `****${last4}` : "";
    const balanceValue = account?.currentBalance;
    const balance =
      balanceValue !== null && balanceValue !== undefined && !Number.isNaN(Number(balanceValue))
        ? `₹${Number(balanceValue).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
        : "";
    return [name, numberLabel, balance].filter(Boolean).join(" • ");
  };

  const load = async ()=>{
    setAccounts(await getAllAccounts());
    setCategories(await getAllCategories());
    setMerchants(await getAllMerchants());
    setTags(await getAllTags());
  };

  const validate = (nextForm)=>{
    const nextErrors = {};
    if (!nextForm.accountId) nextErrors.accountId = "Select an account.";
    if (!nextForm.categoryId) nextErrors.categoryId = "Select a category.";
    const amount = parseFloat(nextForm.amount);
    if (!nextForm.amount || Number.isNaN(amount) || amount <= 0) nextErrors.amount = "Enter a valid amount.";
    if (!nextForm.date) nextErrors.date = "Select a date.";
    return nextErrors;
  };

  const updateField = (field, value)=>{
    setForm(f=>({ ...f, [field]: value }));
    if (errors[field]) {
      setErrors(e=>({ ...e, [field]: undefined }));
    }
  };

  const readErrorMessage = async (res, fallback)=>{
    if (!res) return fallback;
    try {
      const data = await res.clone().json();
      if (typeof data === "string" && data) return data;
      if (data?.message) return data.message;
      if (data?.error) return data.error;
    } catch {}
    try {
      const text = await res.text();
      if (text) return text;
    } catch {}
    return fallback;
  };

  const submit = async (e)=>{
    e.preventDefault();
    const nextErrors = validate(form);
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }
    try {
      const res = await addExpense(form);
      if (!res.ok) {
        const message = await readErrorMessage(res, "Expense not saved.");
        alert(message);
        return;
      }
      alert("Expense added");
    } catch (err) {
      alert(err?.message || "Expense not saved.");
    }
  };

  const toggleTag = (id)=>{
    setForm(f=>({
      ...f,
      tags: f.tags.includes(id) ? f.tags.filter(t=>t!==id) : [...f.tags,id]
    }));
  };

  return (
    <form onSubmit={submit}>
      <div className="card">
  <div className="card-title">Add Expense</div>

  <div className="form-grid">

    <div className="transaction-field">
      <select
        className={`input ${errors.accountId ? "transaction-input-error" : ""}`}
        onChange={e=>updateField("accountId", e.target.value)}
        aria-invalid={Boolean(errors.accountId)}
        required
      >
        <option value="">Select Account</option>
        {accounts.map(a=><option key={a.id} value={a.id}>{formatAccountLabel(a)}</option>)}
      </select>
      {errors.accountId && <div className="transaction-error-text">{errors.accountId}</div>}
    </div>

    <div className="transaction-field">
      <select
        className={`input ${errors.categoryId ? "transaction-input-error" : ""}`}
        onChange={e=>updateField("categoryId", e.target.value)}
        aria-invalid={Boolean(errors.categoryId)}
        required
      >
        <option value="">Select Category</option>
        {categories.map(c=><option key={c.id} value={c.id}>{c.categoryName}</option>)}
      </select>
      {errors.categoryId && <div className="transaction-error-text">{errors.categoryId}</div>}
    </div>

    <div className="transaction-field">
      <select className="input" onChange={e=>updateField("merchantId", e.target.value)}>
        <option value="">Select Merchant</option>
        {merchants.map(m=><option key={m.id} value={m.id}>{m.merchantName}</option>)}
      </select>
    </div>

    <div className="transaction-field">
      <input
        className={`input ${errors.amount ? "transaction-input-error" : ""}`}
        type="number"
        step="0.01"
        min="0.01"
        inputMode="decimal"
        placeholder="Amount"
        onChange={e=>updateField("amount", e.target.value)}
        aria-invalid={Boolean(errors.amount)}
        required
      />
      {errors.amount && <div className="transaction-error-text">{errors.amount}</div>}
    </div>

    <div className="transaction-field">
      <input
        className={`input ${errors.date ? "transaction-input-error" : ""}`}
        type="date"
        onChange={e=>updateField("date", e.target.value)}
        aria-invalid={Boolean(errors.date)}
        required
      />
      {errors.date && <div className="transaction-error-text">{errors.date}</div>}
    </div>

    <div className="transaction-field form-full">
      <textarea className="input" placeholder="Description"
        onChange={e=>updateField("description", e.target.value)} />
    </div>

  </div>

  {/* Tags */}
  <div className="expense-form-tags-wrap">
    {tags.map(t=>(
      <label key={t.id} className="expense-form-tag-pill">
        <input type="checkbox" onChange={()=>toggleTag(t.id)} /> {t.tagName}
      </label>
    ))}
  </div>

  <div className="expense-form-save-wrap">
    <button className="btn btn-primary">Save Expense</button>
  </div>
</div>

    </form>
  );
}
